export const CLIENT_ID = "fa8f6300a03f45b2986157b3a08a8400";
